import React from 'react';
import { TrendingUp, Users, Award, Star } from 'lucide-react';

const Stats = () => {
  const stats = [
    { icon: Users, number: '80+', label: 'Zufriedene Kunden', color: 'from-cyan-600 to-blue-600' },
    { icon: TrendingUp, number: '60%', label: 'Mehr Anfragen Ø', color: 'from-green-600 to-emerald-600' },
    { icon: Award, number: '100%', label: 'Eigentum & Rechte', color: 'from-purple-600 to-pink-600' },
    { icon: Star, number: '4.9/5', label: 'Kundenbewertung', color: 'from-yellow-500 to-orange-500' }
  ];

  return (
    <div className="py-16 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center">
              <div className={`w-20 h-20 bg-gradient-to-br ${stat.color} rounded-full mx-auto mb-4 flex items-center justify-center shadow-2xl`}>
                <stat.icon className="w-10 h-10" />
              </div>
              <div className="text-5xl font-bold mb-2">{stat.number}</div>
              <div className="text-gray-300">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Stats;
